import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  stroke: "#00B448",
  "stroke-width": "1.2",
  "stroke-miterlimit": "10",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "m15.438 5.926 2.64 2.651M9.289 15.905c-1.213-3.153-1.07-6.162 1.427-8.742 1.355-1.361 3.353-1.72 4.994-.931l2.069-2.079a.688.688 0 0 1 .998 0l1.07 1.075a.695.695 0 0 1 0 1.004L17.85 8.238c.785 1.576.428 3.655-.856 4.944-.428.43-1.855 1.147-2.64 1.147 0 0-1.64 3.153-2.925 4.443l-.856.86c-.57.573-1.498.573-1.997 0l-4.21-4.013c-.57-.573-.57-1.505 0-2.007l.857-.86s1.854-1.863 3.424-1.863" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M12.246 16.717s-1.412-4.686.307-4.686M11.57 7.344l5.096 5.119" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }